import script from "./ercCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ercCard.vue?vue&type=script&setup=true&lang=js"

import "./ercCard.vue?vue&type=style&index=0&id=16c7c11c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c7c11c"]])

export default __exports__